<template>
    <div class="pick-list" :class="{'row': !isFloat}">
        <div v-if="!isFloat" class="col-sm-4 field-label">{{ label }}</div>
        <div class="form-group" :class="{'col-sm-8': !isFloat, 'form-group--centered': isCentered }">
            <label v-if="isFloat && label">{{ label }}<span class="pick-list__mandatory" v-if="mandatory">*</span></label>
            <select class="select2" :multiple="isMultiple" :class="{'is-invalid': errors && errors.has(name)}" :id="id"
                    :name="name"
                    v-validate="getValidators" :data-vv-as="label" @change="$emit('change', $event.target.value)">
            </select>
            <div class="invalid-feedback">
                {{ errors && errors.first(name) }}
            </div>

        </div>
    </div>
</template>

<script>
    import formElementMixin from '@/components/mixins/FormElementMixin'
    import select2 from 'select2'

    export default {
        mixins: [formElementMixin],
        props: {
            picklistvalues: {},
            type: {default: 'picklist'},
            searchable: {default: false},
            icon: {}
        },
        created() {

        },
        computed: {
            isMultiple() {
                if (this.type == 'multipicklist') {
                    return true;
                }

                return false;
            },
            element() {
                return $('select.select2', this.$el)
            },
            preparedPicklistValues() {
                if(Array.isArray(this.picklistvalues)) {
                    return this.picklistvalues;
                }
                let preparedValues = [];
                for(const [key, value] of Object.entries(this.picklistvalues)) {
                    preparedValues.push({id: key, text: value})
                }
                return preparedValues
            }
        },
        methods: {
            formatState(state) {
                return $(`<span>${state.text}</span>`);
            }
        },
        mounted() {
            var vm = this
            this.element.select2({
                data: this.preparedPicklistValues,
                placeholder: vm.placeHolder,
                dropdownAutoWidth: true,
                dropdownParent: vm.element.parent(),
                minimumResultsForSearch: vm.searchable ? 0 : -1,
                width: '100%',
                debug: true,
                templateResult: this.formatState,
                templateSelection: this.formatState
            })
            .val(this.value)
            .trigger('change')
            .on('change', function () {
                vm.$emit('input', $(this).val())
            })
        },
        destroyed() {
            this.element.off().select2('destroy')
        }
    }
</script>
<style lang="scss">@import "@/assets/scss/components/form_elements/_picklist.scss";</style>